import apiClient from './api';
import { Service, ServiceType } from '../types/service'; // تأكد من وجود هذا النوع
import { UserRole } from '../types/user';

// واجهة لبيانات إنشاء/تعديل الخدمة
export interface ServiceFormData {
  name: string;
  description: string;
  fee: number;
  type: ServiceType;
}


export const getPublicServices = async (): Promise<Service[]> => {
  const response = await apiClient.get<{ data: Service[] }>('/public/services');
  return response.data.data;
};
/**
 * جلب كل الخدمات
 */
export const getAllServices = async (): Promise<Service[]> => {
  const response = await apiClient.get<{ data: Service[] }>('/services');
  return response.data.data;
};

/**
 * إنشاء خدمة جديدة
 */
export const createService = async (data: ServiceFormData): Promise<Service> => {
  const response = await apiClient.post<{ data: Service }>('/services', data);
  return response.data.data;
};

/**
 * تعديل خدمة موجودة
 */
export const updateService = async (id: number, data: Partial<ServiceFormData>): Promise<Service> => {
  const response = await apiClient.put<{ data: Service }>(`/services/${id}`, data);
  return response.data.data;
};

/**
 * حذف خدمة
 */
export const deleteService = async (id: number): Promise<void> => {
  await apiClient.delete(`/services/${id}`);
};
export const getServicesForCurrentUser = async (): Promise<Service[]> => {
  // نفترض أن لديك نقطة نهاية جديدة لهذا الغرض
  const response = await apiClient.get<{ data: Service[] }>('/services/my-role');
  return response.data.data;
};

/**
 * [ADMIN] جلب قائمة الخدمات التي تستهدف دورًا معينًا
 * @param role - الدور المستهدف
 */
export const getServicesByTargetRole = async (role: UserRole): Promise<Service[]> => {
  // نفترض أن لديك نقطة نهاية جديدة لهذا الغرض
  const response = await apiClient.get<{ data: Service[] }>(`/services/type/${role}`);
  return response.data.data;
};
